/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RoleSummaryBatchResponse {
    getFixupPrototypeFunction() { return RoleSummaryBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<RoleSummaryBatchResponse>): RoleSummaryBatchResponse {
        let obj = Object.assign(new RoleSummaryBatchResponse(), model);
        RoleSummaryBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RoleSummaryBatchResponse>): RoleSummaryBatchResponse {
        if (!model) return null;
        return RoleSummaryBatchResponse.newInstance(<RoleSummaryBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RoleSummaryBatchResponse) {
        if (!obj) return;

        models.RoleSummaryBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RoleSummaryBatchResponse): boolean {
        Object.setPrototypeOf(obj, RoleSummaryBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.RoleSummary.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.RoleSummary; };

}
